@if ((citations()?.length ?? 0) > 0 || reasoning() !== '') {
  <br />
  <div class="expansion-toggle" (click)="toggleCitations()">
    {{ 'INBOX.CITATIONS.SOURCE_MATERIAL' | translate }}
    <mat-icon class="material-symbols-outlined">
      @if (!isExpanded()) {
        expand_more
      } @else {
        expand_less
      }
    </mat-icon>
  </div>

  @if (isExpanded()) {
    <div class="expansion-panel">
      @if (reasoning() !== '') {
        <div class="explanation" [innerHTML]="reasoning()"></div>
      }
      @for (c of citations(); track $index) {
        @if (c.type === CitationType.TYPE_FUNCTION_CALL) {
          <div class="citation">
            <a (click)="openFunctionCallCitationDetails(c)"> {{ c.title }} <mat-icon>offline_bolt</mat-icon> </a>
          </div>
        } @else if (c?.fileUrl && c && supportsFilePreview(c)) {
          <div class="citation file-citation">
            <a (click)="openWebsitePreview(c)">
              <mat-icon class="material-symbols-outlined file-icon">description</mat-icon>
              <div>{{ c.title }}</div>
              <mat-icon class="material-symbols-outlined">visibility</mat-icon>
            </a>
          </div>
        } @else {
          <div class="citation">
            <a href="{{ c.link }}" target="_blank" rel="noreferrer noopener">
              <div>{{ c.title }}</div>
              <mat-icon class="material-symbols-outlined">open_in_new</mat-icon>
            </a>
          </div>
        }
      }
    </div>
    <div class="internal-only">
      <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
      {{ 'INBOX.CITATIONS.INTERNAL_ONLY' | translate }}
    </div>
  }
}
